import { render, staticRenderFns } from "./VxPageTitleActions.vue?vue&type=template&id=03e8b082&"
import script from "./VxPageTitleActions.vue?vue&type=script&lang=js&"
export * from "./VxPageTitleActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports